import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Input from "../../Components/Input/Input";
import { useNavigate } from "react-router-dom";

import { addReferralUser, addUser, getferralUsers, getUserList, searchUser } from "../../utils/api";
import GloabalLoader from "../../Components/Loader/GloabalLoader";
import {

  checkValidity,
  isAlphabet,
  isEmpty,
  isNumber,
} from "../../utils/common";
import { AlertWrapper } from "../../Components/Modal/style";
import { useSelector } from "react-redux";
require("react-datepicker/dist/react-datepicker.css");

const Addb2buser = () => {
  const initialValues = {
    email: "",
    firstName: "",
    lastName: "",
    userName: "",
    mobileNumber:""

  };
  const [userData, setUserData] = useState({ ...initialValues });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [rasponseData, setResponseData] = useState({});
  const [message, setMessage] = useState({});
  const [confirmMsg, setConfirm] = useState({});
  const [loginUserType, setLoginUserTye] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);
  const [distributor, setDistributor] = useState("");
  const [distributorData, setDistributorData] = useState({});
   const [popupLoader, setPopupLoader] = useState(false);
   const [searchDate, setSearchDate] = useState({ found:"", data:{}});
   const [searchLoader, setSearchLoader] = useState(false);


  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  //DatePicker
  var maxBirthdayDate = new Date();
  maxBirthdayDate.setFullYear(maxBirthdayDate.getFullYear() - 18);
  const years = [];
  const currentYear = new Date().getFullYear();
  for (let year = currentYear; year >= 1900; year--) {
    years.push(year);
  }

 
    const handleFormData = async (e) => {
   
  
      let error = {};
      if ((userData?.userName === "") || (userData?.userName.length < 4) ) {
        error.userName = "Please enter at least 4 characters username";
      } else if (userData.mobileNumber === "") {
        error.mobileNumber = "Please enter mobile number";
      } else if (userData.mobileNumber.length < 10) {
        error.mobileNumber = "Mobile number can't be less than 10 digits";
      }
      if (userData.firstName === "") {
        error.firstName = "Please enter first name";
      }
      if (userData.email === "" || !checkValidity(userData.email,{isEmail:true})) {
        error.email = "Please enter valid email";
      }

      if (isEmpty(distributorData?.firstName) && (user?.userType !== "ROLE_DISTRIBUTOR")) {
        error.distributor = "Please enter distributor username";
      };


  
     

  
      setErrors(error);
  
      if (isEmpty(error)) {
        setDisableBtn(true);
        setLoading(true);
       
        const params ={
          userId:userData.userName ,
         mobileNumber:userData.mobileNumber,
         email:userData.email,
         name: `${userData?.firstName} ${userData?.lastName || ""}`.trim(),
         refUserId:user?.userType !== "ROLE_DISTRIBUTOR"?distributorData?.uuid:user?.uuid, 
     };
     addReferralUser(params).then((resp) => {
          if (resp?.data?.success === true) {
            setMessage({ msg: "User registered successfully.", type: "success" });
  
            setTimeout(() => {
              navigate("/referral-users");
              setDisableBtn(false);
              setLoading(false);
            }, 2000);
          } else {
            setLoading(false);
            let msg = "";
            if (resp?.data?.errorCodeList.length > 0) {
              msg = resp?.data?.errorCodeList[0];
            } else {
              msg = resp?.data?.msg;
            }
            setMessage({ msg: msg, type: "error" });
            setDisableBtn(false);
          }
        });
      }
    };

  const handleInput = (e, key = "") => {
    let name, value;
    name = e.target.name;
    value = e.target.value;
    setErrors({});
    if (key === "number") {
      value = e.target.value.trim();
    }

    if (key === "number") {
      if (!isNumber(value) && !isEmpty(value)) return;
    } else if (key === "text") {
      if (!isAlphabet(value) && !isEmpty(value)) {
        return;
      }
    }
    if(name === "userName"){
      setSearchDate({ found:"", data:{}});
    }
    setUserData({ ...userData, [name]: value });

    
  };



  const confirmHandler = (screenCode, type = "") => {
    if (type === "redirect") {
      const userData = {
        email: rasponseData.email,
        userName: rasponseData.userName,
        uuid: rasponseData.uuid,
      };
      if (screenCode === "USER_REGISTRATION") {
        navigate("/select-package", { state: userData });
      } else if (screenCode === "USER_KYC") {
        navigate("/Verification", { state: { userData: userData, skip: "" } });
      } else if (screenCode === "PACKAGE_ASSIGNED") {
        navigate("/bankdetails", { state: userData });
      }
    }

    if (type === "yes") {
      setConfirm({});
    }
  };
  useEffect(() => {
    if (!isEmpty(message)) {
      setTimeout(() => {
        setMessage({});
      }, 4000);
    }
  });



  useEffect(() => {
    if (loginUserType === "") {
      setLoginUserTye(user?.userType);
    }
  }, [user]);




  const changeDistributor = (e) =>{
    let {value}  = e.target;
    value = value.trim();
    if (!isNumber(value) && !isEmpty(value)) return;
    setDistributor(value)
    setDistributorData({});
    setErrors({...errors,distributor:""});
    if(value?.length === 10){
      getDestributer(value)
    }
    
  }


   const getDestributer = async (mobile) => {
      const param = {
        fromDate: "",
        toDate: "",
        username: mobile,
        name: "",
        userType: "ROLE_DISTRIBUTOR",
      };
  
      const pagination = {
        currentPage: 0,
        pageSize: 1,
      };
      setPopupLoader(true)
      getUserList(param, pagination).then((resp) => {
        setPopupLoader(false)
        if (resp?.data.success) {
          if (resp?.data?.data?.content && resp?.data?.data?.content?.length) {
            setDistributorData(resp?.data?.data?.content[0]);
          }
        }
      });
    };
  

      const handleApiData = async (e, key) => {
        setSearchLoader(true);

        if(isEmpty(userData?.userName) && userData?.userName.length < 4){
          setErrors({...errors,userName:"Please enter at least 4 characters"})
        }
    
        const param = {
        username:userData?.userName,
       pageNo:0,
       pageSize:1
        };
    
      
        getferralUsers(param).then((resp) => {
          setSearchLoader(false);
       
          if (resp?.data.success) {
            if(isEmpty(resp?.data?.data?.content?.[0])){

              setSearchDate({
                found:"notFound",
                data:{}
              })
              
            }else{

              setSearchDate({
                found:"found",
                data:resp?.data?.data?.content[0],
              })

            }
        
          }
        });
      };

  

  return (
    <>
      {!isEmpty(message) && (
        <AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage({})}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="main_container">
        <div className="container1">
          {/* <label>Create New Retailer</label> */}
          <label>Create New Referral User</label>
        </div>
        <div
          className={`container_form ${
            userData.userType !== "ROLE_RETAILER" && ""
          }`}
        >
      
          <div className="shadowBox">
            <div className="">
              <div className="">
                <h3>Personal Details</h3>
              </div>
            </div>

            <div className="role role_responsive">
             <div className="retailer">
             <div className="">
                <div className="labelname">
                  <label>Username</label>
                  <span className="required"> *</span>
                </div>
                <Input
                  type="text"
                  placeholder="Enter username number"
                  name="userName"
                  value={userData?.userName}
                  onChange={(e) => handleInput(e, "")}
                  className="searchUser"
                  click={handleApiData}
                />
                {errors.userName && (
                  <p className="error fs-12 mt-10">{errors.userName}</p>
                )}
              </div>
              {searchLoader && (
                      <div className="mt-10" style={{ fontSize: "10px" }}>
                        Loading...
                      </div>
                    )}
                    {!searchLoader &&
                      searchDate.found === "notFound" &&
                      isEmpty(searchDate?.data) && (
                        <div className="mt-10" style={{ fontSize: "10px", color:"green"}}>
                        This username is available
                      </div>
                      )}
                      
                    {!isEmpty(searchDate?.data) &&
                      searchDate.found === "found" && (
                        <>
                          

                          <div className="mt-10" style={{ fontSize: "10px", color:"red"}}>
                          Username already exists  
                        </div>
                        
                        </>
                      )}
             
             </div>

             {user?.userType !== "ROLE_DISTRIBUTOR" && <div className="retailer">
             <div className="">
                <div className="labelname">
                  <label>Distributor</label>
                  <span className="required">*</span>
                </div>
                <Input
                  type="text"
                  maxLength={10}
                  placeholder="Enter username"
                  name="distributor"
                  value={distributor}
                  onChange={(e) => changeDistributor(e)}
                  className="searchUser"
                  click={() =>{}}
                />
                {errors.distributor && (
                  <p className="error fs-12 mt-10">{errors.distributor}</p>
                )}
              </div>
              
          
              {popupLoader && (
                      <div className="mt-10" style={{ fontSize: "10px" }}>
                        Loading...
                      </div>
                    )}
                    {!popupLoader &&
                      distributor.length === 10 &&
                      isEmpty(distributorData) && (
                        <div className="mt-10" style={{ fontSize: "10px", color:"red"}}>
                          Distributor not found
                        </div>
                      )}

                    {!isEmpty(distributorData) &&
                      distributor.length === 10 && (
                        <>
                          <div className="flex row">
                            <lable className=" flex fs-12 gap-10 mt-10">
                              Name:
                              <span className="blue_font fw-bold">
                                {(distributorData?.firstName || "") +
                                  " " +
                                  (distributorData.lastName || "")}
                              </span>
                            </lable>
                          </div>
                        
                        </>
                      )}
             </div>}
          
            
            </div>
          

            <div className="role role_responsive">
            <div className="retailer">
                <div className="labelname">
                  <label>First Name</label>
                  <span className="required"> *</span>
                </div>
                <div>
                  <Input
                    className="inputtype"
                    type="text"
                    placeholder="Enter first name"
                    name="firstName"
                    value={userData.firstName}
                    onChange={(e) => handleInput(e, "text")}
                  />
                  {errors.firstName && (
                    <p className="error fs-12 mt-10">{errors.firstName}</p>
                  )}
                </div>
              </div>
            
              <div className="retailer">
                <div className="labelname" style={{marginBottom:"4px"}}>
                  <label>Last Name</label>
                  <span className="required"></span>
                </div>
                <Input
                  className="inputtype"
                  type="text"
                  placeholder="Enter last name"
                  name="lastName"
                  value={userData.lastName}
                  onChange={(e) => handleInput(e, "text")}
                />
                {errors.lastName && (
                  <p className="error fs-12 mt-10">{errors.lastName}</p>
                )}
              </div>
            
            </div>

            <div className="role role_responsive">
            <div className="retailer">
                <div className="labelname">
                  <label>Mobile Number</label>
                  <span className="required"> *</span>
                </div>
                <div>
                  <Input
                    className="inputtype"
                    type="text"
                    placeholder="Enter mobile number"
                    name="mobileNumber"
                    value={userData.mobileNumber}
                    maxLength={10}
                    onChange={(e) => handleInput(e, "number")}
                  />
                  {errors?.mobileNumber && (
                    <p className="error fs-12 mt-10">{errors?.mobileNumber}</p>
                  )}
                </div>
              </div>

            <div className="retailer">
                <div className="labelname">
                  <label>Email</label>
                  <span className="required"> *</span>
                </div>
                <div>
                  <Input
                    className="inputtype"
                    type="text"
                    placeholder="Enter email"
                    name="email"
                    value={userData.email}
                    onChange={(e) => handleInput(e, "email")}
                  />
                  {errors?.email && (
                    <p className="error fs-12 mt-10">{errors?.email}</p>
                  )}
                </div>
              </div>

            </div>
          
            <div className="role role_responsive">
              <div className="retailer">
                <button
                  className="submit_btn "
                  disabled={disableBtn}
                  onClick={() => {
                    handleFormData();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
         
          {/* Address Details */}
         
         
        </div>
        <>{loading && <GloabalLoader />}</>
      </div>
    </>
  );
};
export default Addb2buser;
